import React from "react";
import images from "../../../../utilities/images/images";
import ProgressBar from "../../../../custom_utilities/ProgressBar/ProgressBar";
import "./DayStreak.css";

/** Maps milestone API `is_progress` to 0–100 for the shared ProgressBar. */
function progressFromApi(raw) {
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  if (Number.isNaN(n) || n < 0) return null;
  if (n > 100) return 100;
  if (n > 0 && n < 1 && !Number.isInteger(n)) return Math.round(n * 100);
  return Math.round(n);
}

function DayStreak({
  badgeUrl = images.streak,
  title = "100 Day Streak",
  subtitle = "2 milestones away to become a LEGENDARY",
  statusLabel = "LEGEND",
  isProgress,
}) {
  const progressPct = progressFromApi(isProgress);
  const showProgress = progressPct != null;

  return (
    <section className="day-streak">
      <div className="day-streak__left">
        <img src={badgeUrl} alt="" className="day-streak__badge" />

        <div className="day-streak__content">
          <h3 className="day-streak__title">{title}</h3>

          {showProgress ? (
            <div className="day-streak__progress">
              <ProgressBar
                progress={progressPct}
                height="8px"
                fillStyle={{
                  background: "linear-gradient(90deg, #f97316 0%, #facc15 100%)",
                }}
              />
            </div>
          ) : null}

          <p className="day-streak__subtitle">{subtitle}</p>
        </div>
      </div>

      <span className="day-streak__tag">{statusLabel}</span>
    </section>
  );
}

export default DayStreak;
